import { IconProps } from '../../types/components';

export const TransactionsMarketIcon = ({
  fillColor = 'currentColor',
  cy,
}: IconProps) => {
  return (
    <svg
      width="26"
      height="36"
      viewBox="0 0 28 36"
      xmlns="http://www.w3.org/2000/svg"
      cy={cy}
    >
      <path
        d="M16.3008 16.3837C15.5664 15.9892 14.6388 15.8352 13.6734 15.6997C13.3475 15.6542 13.2005 15.524 13.1811 15.4477C13.1593 15.362 13.2468 15.1361 13.5738 14.8946C14.4092 14.2776 15.6192 15.253 15.6314 15.2629L16.3261 14.4256L17.0259 13.5925C16.9639 13.5406 16.3972 13.0755 15.5891 12.7738C15.4954 12.7388 15.4019 12.7085 15.3086 12.6806V12H13.1326V12.6938C12.8327 12.7989 12.547 12.948 12.2817 13.1438C11.2641 13.895 10.8119 14.9561 11.0722 15.9823C11.3234 16.9735 12.2045 17.6908 13.3716 17.8545C15.5825 18.1645 15.5481 18.4447 15.5049 18.7999C15.4853 18.9604 15.4178 19.1907 15.0608 19.3359C14.4843 19.57 13.403 19.4516 12.3905 18.6377L11.0275 20.3339C11.6769 20.8558 12.402 21.2266 13.1328 21.4317V22.2437H15.3087V21.5272C15.5054 21.484 15.6968 21.4262 15.8804 21.3515C16.8867 20.9423 17.5371 20.1085 17.6647 19.0636C17.8085 17.8849 17.3243 16.933 16.3008 16.3837Z"
        fill={fillColor}
      />
      <path
        d="M24 7L20.01 3L20.01 6L10 6L10 8L20.01 8L20.01 11L24 7ZM24 7L20.01 3L20.01 6L10 6L10 8L20.01 8L20.01 11L24 7Z"
        fill={fillColor}
      />
      <path
        d="M6 27L9.99 31L9.99 28L20 28L20 26L9.99 26L9.99 23L6 27ZM6 27L9.99 31L9.99 28L20 28L20 26L9.99 26L9.99 23L6 27Z"
        fill={fillColor}
      />
    </svg>
  );
};
